"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitShapes = exports.CookieNotificationAlertKind = exports.TextOrientationKind = exports.DateSettingSeparatorKind = exports.DateTimeSettingKind = exports.CurrencyThousandSeparatorKind = exports.CurrencySymbolPlacementKind = exports.CurrencyGroupingSymbolKind = exports.NumberThousandSeparatorKind = exports.UnitSymbolPlacementKind = exports.NumberGroupingSymbolKind = void 0;
var NumberGroupingSymbolKind;
(function (NumberGroupingSymbolKind) {
    NumberGroupingSymbolKind[NumberGroupingSymbolKind["dot"] = 0] = "dot";
    NumberGroupingSymbolKind[NumberGroupingSymbolKind["comma"] = 1] = "comma";
})(NumberGroupingSymbolKind = exports.NumberGroupingSymbolKind || (exports.NumberGroupingSymbolKind = {}));
var UnitSymbolPlacementKind;
(function (UnitSymbolPlacementKind) {
    UnitSymbolPlacementKind[UnitSymbolPlacementKind["none"] = 0] = "none";
    UnitSymbolPlacementKind[UnitSymbolPlacementKind["beforeValue"] = 1] = "beforeValue";
    UnitSymbolPlacementKind[UnitSymbolPlacementKind["afterValue"] = 2] = "afterValue";
})(UnitSymbolPlacementKind = exports.UnitSymbolPlacementKind || (exports.UnitSymbolPlacementKind = {}));
var NumberThousandSeparatorKind;
(function (NumberThousandSeparatorKind) {
    NumberThousandSeparatorKind[NumberThousandSeparatorKind["dot"] = 0] = "dot";
    NumberThousandSeparatorKind[NumberThousandSeparatorKind["comma"] = 1] = "comma";
    NumberThousandSeparatorKind[NumberThousandSeparatorKind["space"] = 2] = "space";
})(NumberThousandSeparatorKind = exports.NumberThousandSeparatorKind || (exports.NumberThousandSeparatorKind = {}));
var CurrencyGroupingSymbolKind;
(function (CurrencyGroupingSymbolKind) {
    CurrencyGroupingSymbolKind[CurrencyGroupingSymbolKind["dot"] = 0] = "dot";
    CurrencyGroupingSymbolKind[CurrencyGroupingSymbolKind["comma"] = 1] = "comma";
})(CurrencyGroupingSymbolKind = exports.CurrencyGroupingSymbolKind || (exports.CurrencyGroupingSymbolKind = {}));
var CurrencySymbolPlacementKind;
(function (CurrencySymbolPlacementKind) {
    CurrencySymbolPlacementKind[CurrencySymbolPlacementKind["beforePrice"] = 0] = "beforePrice";
    CurrencySymbolPlacementKind[CurrencySymbolPlacementKind["afterPrice"] = 1] = "afterPrice";
})(CurrencySymbolPlacementKind = exports.CurrencySymbolPlacementKind || (exports.CurrencySymbolPlacementKind = {}));
var CurrencyThousandSeparatorKind;
(function (CurrencyThousandSeparatorKind) {
    CurrencyThousandSeparatorKind[CurrencyThousandSeparatorKind["dot"] = 0] = "dot";
    CurrencyThousandSeparatorKind[CurrencyThousandSeparatorKind["comma"] = 1] = "comma";
    CurrencyThousandSeparatorKind[CurrencyThousandSeparatorKind["space"] = 2] = "space";
})(CurrencyThousandSeparatorKind = exports.CurrencyThousandSeparatorKind || (exports.CurrencyThousandSeparatorKind = {}));
var DateTimeSettingKind;
(function (DateTimeSettingKind) {
    DateTimeSettingKind[DateTimeSettingKind["date"] = 0] = "date";
    DateTimeSettingKind[DateTimeSettingKind["dateTime"] = 1] = "dateTime";
})(DateTimeSettingKind = exports.DateTimeSettingKind || (exports.DateTimeSettingKind = {}));
var DateSettingSeparatorKind;
(function (DateSettingSeparatorKind) {
    DateSettingSeparatorKind[DateSettingSeparatorKind["dot"] = 0] = "dot";
    DateSettingSeparatorKind[DateSettingSeparatorKind["dash"] = 3] = "dash";
    DateSettingSeparatorKind[DateSettingSeparatorKind["slash"] = 4] = "slash";
})(DateSettingSeparatorKind = exports.DateSettingSeparatorKind || (exports.DateSettingSeparatorKind = {}));
var TextOrientationKind;
(function (TextOrientationKind) {
    TextOrientationKind[TextOrientationKind["rightToLeft"] = 0] = "rightToLeft";
    TextOrientationKind[TextOrientationKind["leftToRight"] = 1] = "leftToRight";
})(TextOrientationKind = exports.TextOrientationKind || (exports.TextOrientationKind = {}));
var CookieNotificationAlertKind;
(function (CookieNotificationAlertKind) {
    CookieNotificationAlertKind[CookieNotificationAlertKind["noNotification"] = 0] = "noNotification";
    CookieNotificationAlertKind[CookieNotificationAlertKind["linkToDetail"] = 1] = "linkToDetail";
    CookieNotificationAlertKind[CookieNotificationAlertKind["requestChoice"] = 2] = "requestChoice";
    CookieNotificationAlertKind[CookieNotificationAlertKind["splashScreenWithDetail"] = 3] = "splashScreenWithDetail";
    CookieNotificationAlertKind[CookieNotificationAlertKind["linkToDetailInformed"] = 4] = "linkToDetailInformed";
})(CookieNotificationAlertKind = exports.CookieNotificationAlertKind || (exports.CookieNotificationAlertKind = {}));
var DigitShapes;
(function (DigitShapes) {
    DigitShapes[DigitShapes["context"] = 0] = "context";
    DigitShapes[DigitShapes["none"] = 1] = "none";
    DigitShapes[DigitShapes["nativeNational"] = 2] = "nativeNational";
})(DigitShapes = exports.DigitShapes || (exports.DigitShapes = {}));
